/**
 * Directive for account switcher dropdown in navbar
 */
(function () {
    'use strict';

    angular
        .module('App.v1.Directives')
        .directive('accountSwitcher', accountSwitcher);

    function accountSwitcher() {
        return {
            restrict: 'E',
            scope: {},  // Isolated scope to prevent conflicts with page controllers
            template: `
                <li class="nav-item dropdown" ng-if="vm.isSignedIn">
                    <a class="nav-link dropdown-toggle" 
                       href="#" 
                       id="navbarAccountDropdown" 
                       role="button" 
                       data-toggle="dropdown" 
                       aria-haspopup="true" 
                       aria-expanded="false">
                        <i class="fa fa-building"></i> 
                        <span ng-if="vm.currentAccount">{{ vm.currentAccount.organizationShortName || vm.currentAccount.organizationName }}</span>
                        <span ng-if="!vm.currentAccount">...</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarAccountDropdown">
                        <h6 class="dropdown-header">Switch Account</h6>
                        <a class="dropdown-item" 
                           ng-repeat="account in vm.accounts" 
                           ng-click="vm.switchToAccount(account)"
                           ng-class="{'active': account.accountId === vm.currentAccountId}"
                           href="#">
                            <i class="fa fa-check" ng-if="account.accountId === vm.currentAccountId"></i>
                            <span ng-if="account.accountId !== vm.currentAccountId" style="padding-left: 20px;"></span>
                            {{ account.organizationName }}
                            <small class="text-muted">({{ account.role }})</small>
                        </a>
                        <div class="dropdown-divider" ng-if="vm.accounts.length > 0"></div>
                        <a class="dropdown-item" href="/account/setup">
                            <i class="fa fa-plus"></i> Create New Account
                        </a>
                    </div>
                </li>
            `,
            controller: AccountSwitcherController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    AccountSwitcherController.$inject = ['App.v1.Services.AccountService', '$window', '$scope'];
    function AccountSwitcherController(AccountService, $window, $scope) {
        var vm = this;
        
        vm.isSignedIn = $window.IsSignedIn;
        vm.accounts = [];
        vm.currentAccount = null;
        vm.currentAccountId = null;
        vm.switchToAccount = switchToAccount;

        activate();

        // React to account context changes broadcast by AccountService
        $scope.$on('accountService:updated', function(event, data) {
            vm.accounts = data.accounts;
            vm.currentAccount = data.currentAccount;
            vm.currentAccountId = data.currentAccount ? data.currentAccount.accountId : null;
        });

        function activate() {
            if (!vm.isSignedIn) {
                return;
            }

            // AccountService.initializeAccountContext() runs on service load and owns
            // account state. If it has already resolved before this directive rendered,
            // hydrate from the service directly; otherwise the $on listener above handles it.
            if (AccountService.accounts.length > 0) {
                vm.accounts = AccountService.accounts;
                vm.currentAccount = AccountService.currentAccount;
                vm.currentAccountId = AccountService.currentAccount ? AccountService.currentAccount.accountId : null;
            }
        }

        function switchToAccount(account) {
            AccountService.switchToAccount(account);
        }
    }
})();
